import script from "./marketing-preference-toggles.vue?vue&type=script&lang=ts&setup=true"
export * from "./marketing-preference-toggles.vue?vue&type=script&lang=ts&setup=true"

import "./marketing-preference-toggles.vue?vue&type=style&index=0&id=1d72dd38&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d72dd38"]])

export default __exports__